var _defs, _rect, _polygon, _polygon2, _polygon3, _rect2, _polygon4, _polygon5, _polygon6, _rect3, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10034IconServiceVmScaleSets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a2157f88-f641-4f7d-abc7-f40ccf5cf69a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b816c8ea-05a2-41fb-ba99-96d84599c9f4",
    x1: 12.74,
    y1: 15.28,
    x2: 12.74,
    y2: 8.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab373d88-41af-4fc3-b172-d4489f9107a0",
    x1: 12.74,
    y1: 17.89,
    x2: 12.74,
    y2: 15.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-compute-34") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.79,
    y: 0.89,
    width: 10.11,
    height: 6.75,
    rx: 0.34,
    fill: "#005ba1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.53 3.28 7.53 5.25 5.85 6.23 5.85 4.27 7.53 3.28",
    fill: "#50e6ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "7.53 3.28 5.85 4.27 4.16 3.28 5.85 2.29 7.53 3.28",
    fill: "#c3f1ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "5.85 4.27 5.85 6.23 4.16 5.25 4.16 3.28 5.85 4.27",
    fill: "#9cebff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76,
    y: 4.76,
    width: 10.11,
    height: 6.75,
    rx: 0.34,
    fill: "#0078d4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.5 7.16 11.5 9.12 9.82 10.11 9.82 8.14 11.5 7.16",
    fill: "#50e6ff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.5 7.16 9.82 8.14 8.13 7.16 9.82 6.17 11.5 7.16",
    fill: "#c3f1ff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "9.82 8.14 9.82 10.11 8.13 9.12 8.13 7.16 9.82 8.14",
    fill: "#9cebff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.68,
    y: 8.52,
    width: 10.11,
    height: 6.75,
    rx: 0.34,
    fill: "url(#b816c8ea-05a2-41fb-ba99-96d84599c9f4)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.42 10.92 14.42 12.88 12.74 13.87 12.74 11.9 14.42 10.92",
    fill: "#50e6ff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.42 10.92 12.74 11.91 11.05 10.92 12.74 9.93 14.42 10.92",
    fill: "#c3f1ff"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.74 11.91 12.74 13.87 11.05 12.88 11.05 10.92 12.74 11.91",
    fill: "#9cebff"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.05 12.88 12.74 11.9 12.74 13.87 11.05 12.88",
    fill: "#c3f1ff"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.42 12.88 12.74 11.9 12.74 13.87 14.42 12.88",
    fill: "#9cebff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.76,17.32c-1-.16-1-.88-1-2h-2c0,1.16,0,1.88-1,2a.59.59,0,0,0-.5.57h5A.59.59,0,0,0,14.76,17.32Z",
    fill: "url(#ab373d88-41af-4fc3-b172-d4489f9107a0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10034IconServiceVmScaleSets);
export default __webpack_public_path__ + "static/media/10034-icon-service-VM-Scale-Sets.20cf3acc3f6db446856c31bc4d3a9ba2.svg";
export { ForwardRef as ReactComponent };